import { validatePdfBlob } from "../services/documentExportService";

export const printDocument = (blob: Blob): Promise<void> => {
  const url = URL.createObjectURL(validatePdfBlob(blob));
  const frame = document.createElement("iframe");
  frame.title = "Printable PDF";
  frame.style.position = "fixed";
  frame.style.width = "1px";
  frame.style.height = "1px";
  frame.style.right = "0";
  frame.style.bottom = "0";
  frame.style.border = "0";
  frame.style.opacity = "0";
  frame.style.pointerEvents = "none";

  const cleanUp = () => {
    URL.revokeObjectURL(url);
    frame.remove();
  };

  return new Promise((resolve, reject) => {
    frame.onload = () => {
      const printWindow = frame.contentWindow;
      if (!printWindow) {
        cleanUp();
        reject(new Error("PRINT_CONTEXT_UNAVAILABLE"));
        return;
      }

      try {
        printWindow.focus();
        printWindow.print();
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        setTimeout(cleanUp, 1000);
      }
    };
    frame.onerror = () => {
      cleanUp();
      reject(new Error("PRINT_CONTEXT_UNAVAILABLE"));
    };
    frame.src = url;
    document.body.appendChild(frame);
  });
};
